<template>
  <nav aria-label="breadcrumb">
    <ol class="px-0 pt-1 pb-0 mb-0 bg-transparent breadcrumb" :class="isRTL ? '' : ' me-sm-6'">
      <li class="text-sm breadcrumb-item" :class="color">        
        <a :class="color" class="opacity-8" href="../">          
          {{ $t('common.Home') }}
        </a>
      </li>
      <li class="text-sm breadcrumb-item active" v-if="currentPage !== 'Home'" :class="color" aria-current="page">
        {{ $t(`topmenu.${pageKey}`) }}
      </li>
    </ol>
    <!--
    <h6 class="mb-0 font-weight-bolder" :class="color">
      {{ $t(`topmenu.${pageKey}`) }}
    </h6>
    -->
  </nav>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Bread_crumbs",
  props: {
    currentPage: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: "text-dark",
    },
  },
  computed: {
    ...mapState(["isRTL"]),
  
    pageKey() {
      //console.log(this.currentPage);
      switch (this.currentPage) {
        case 'Animal': return 'Animal'
        case 'New Animal': return 'New_Animal'
        case 'Edit Animal': return 'Edit_Animal'
        case 'Edit Inactive Animal': return 'Edit_Inactive_Animal'
        case 'Logbook': return 'Logbook'
        case 'Import': return 'Import'
        case 'Export': return 'Export'        
        case 'Death': return 'Death'
        case 'New Death': return 'New_Death'
        case 'Edit Death': return 'Edit_Death'
        case 'Missing': return 'Missing'
        case 'New Missing': return 'New_Missing'
        case 'Edit Missing': return 'Edit_Missing'
        case 'Login': return 'Login'
        case 'ResetPassword': return 'ResetPassword'
        case 'signup': return 'Signup'
        case 'aboutus': return 'Aboutus'
        case 'Profile': return 'Profile'
        case 'User': return 'User'
        case 'New User': return 'New_User'
        case 'Edit User': return 'Edit_User'
        case 'Location': return 'Location'
        case 'New Location': return 'New_Location'
        case 'Edit Location': return 'Edit_Location'
        case 'Preview Location': return 'Preview_Location'
        case 'Mating': return 'Mating'
        case 'New Mating': return 'New_Mating'
        case 'New Testmating': return 'New_Testmating'
        case 'Edit Mating': return 'Edit_Mating'
        case 'Preview Mating': return 'Preview_Mating'
        case 'Birth': return 'Birth'
        case 'Register Birth': return 'Register_Birth'
        case 'Register NewBorn': return 'Register_NewBorn'
        case 'Eartag': return 'Eartags'
        case 'Preview Eartag': return 'Preview_Eartag'
        case 'New ReferenceType': return 'New_ReferenceType'
        case 'Edit ReferenceType': return 'Edit_ReferenceType'
        case 'New Reference': return 'New_Reference'
        case 'Edit Reference': return 'Edit_Reference'
        case 'Register': return 'Register'
        case 'New Register': return 'New_Register'
        case 'Edit Register': return 'Edit_Register'
        case 'Association': return 'Association'
        case 'New Association': return 'New_Association'
        case 'Edit Association': return 'Edit_Association'
        case 'Preview Association': return 'Preview_Association'
        case 'Settings': return 'Settings'
        case 'New Breed': return 'New_Breed'
        case 'Edit Breed': return 'Edit_Breed'
        case 'New StudebookStatus': return 'New_StudebookStatus'
        case 'Edit StudebookStatus': return 'Edit_StudebookStatus'
        case 'New StudebookSection': return 'New_StudebookSection'
        case 'Edit StudebookSection': return 'Edit_StudebookSection'
        case 'New MailTemplate': return 'Edit_MailTemplate'
        case 'Edit MailTemplate': return 'Edit_MailTemplate'
        case 'Report Testmating': return 'Report_Testmating'
        case 'New Attribute': return 'New_Attribute'
        case 'Edit Attribute': return 'Edit_Attribute'
        case 'Departure': return 'Departure'
        case 'New Departure': return 'New_Departure'
        case 'Edit Departure': return 'Edit_Departure' 
        case 'New UserManualType': return 'New_UserManualType'
        case 'Edit UserManualType': return 'Edit_UserManualType'
        case 'New UserManual': return 'New_UserManual'
        case 'Edit UserManual': return 'Edit_UserManual'
        case 'New Notification': return 'New_Notification'
        case 'Edit Notification': return 'Edit_Notification'
        case 'Report Stablelist': return 'Stablelist'
        case 'Report Invullijst': return 'Invullijst'
        case 'Retagging': return 'Retagging'
        case 'Aretagging': return 'Retagging'
        case 'Animal Pedigree': return 'Animal_Pedigree'
        case 'Preview Animal': return 'Preview_Animal'
        case 'Overview Death': return 'Overview_Death'
        case 'Overview Departure': return 'Overview_Departure'
        case 'New Retagging': return 'New_Retagging'
        case 'Controle RVO': return 'CheckRvo'
        case 'RVO berichten logboek': return 'ActivityLog'
        default:
          return this.currentPage
      }
    }
  }
};
</script>
